import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import OfferSources from './OfferSources';
import OfferCardItem from './OfferCardItem';
import { FMessage } from '../../hoc/IntlComponents';

const OfferRequestSuccessModal = ({ open, toggle, offer, sources, intl }) => (
  <Modal
    backdrop="static"
    toggle={toggle}
    isOpen={open}
    centered
    className="offer-access-success-modal"
  >
    <ModalBody className="offer_allowed_access_granted">
      <p className="offer-access-success-modal-title">
        <FMessage id="offer.allowed-access.title" />
      </p>
      <button className="offer-access-success-modal-close" onClick={toggle} />
      <div>
        <p className="mb-2">
          {offer &&
            offer.title &&
            intl.formatMessage(
              {
                id: 'offer.allowed-access.message',
                defaultMessage: `Access to «{offer}» is provided`,
              },
              { offer: offer.title },
            )}
          {'. '}
        </p>
        <p className="mb-3">
          <FMessage id="offer.allowed-access.wish" />
        </p>

        <div className="offer_sources mb-4">
          {sources && offer && offer.sources && offer.sources.length > 0 && (
            <OfferSources
              sources={sources}
              selected={offer.sources}
              invert={offer.sources_inversion}
            />
          )}
        </div>

        {offer && offer.rules && (
          <>
            <h6>
              <b>
                <FMessage id="offer.rules" />
              </b>
            </h6>
            <OfferCardItem
              id="offer.rules"
              className="offer-rules"
              defaultMessage="Offer's Rules"
              html={offer.rules}
            />
          </>
        )}
      </div>
    </ModalBody>
  </Modal>
);

export default OfferRequestSuccessModal;
